// extracted by mini-css-extract-plugin
export var standaloneTable = "_h5-0";
export var standaloneTableWithBodyFill = "_h5-1";
export var withExtraHeader = "_h5-2";